import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './RoleListItemContent.module.css'

function RoleListItemContent({ isActive, isHovered, showTooltip, value }) {
  const { value: id } = value

  const { t } = useTranslation()

  const text = id === null ? value.label : ROLE_TRANSLATION_ALIASES[id]

  const textClassName = classNames(styles.text, {
    [styles.hover]: isActive || isHovered,
  })

  return (
    <FloatingTooltip content={t(text)} disabled={!showTooltip}>
      <Text className={textClassName}>{t(text)}</Text>
    </FloatingTooltip>
  )
}

export default RoleListItemContent
